import styled from "styled-components";

const SubmitStyle = styled.input`
   border: none;
   font-size: 16px;
   padding: 15px;
   margin: 15px;
   border-radius: 15px;
   cursor: pointer;
   background-color: ${props => props.backgroundColor};
   color: #f5f0e5;
   z-index: 999999999;
`

function SubmitBtn() {

    return (

          <SubmitStyle type="submit" label ="submit" value="Subscribe" backgroundColor={"#d64f40"} />

    );
  }
  
  export default SubmitBtn;